<div
  [formGroup]="formGroup"
  *ngIf="variant === 'basic'"
  id="checkbox-basic-container"
>
  <tui-checkbox
    [formControlName]="formControlName"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [readOnly]="properties?.readOnly ?? false"
    [size]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <span [innerHTML]="label | kwikuiSafeHtml"></span>
  </tui-checkbox>
</div>
<div
  [formGroup]="formGroup"
  *ngIf="variant === 'labeled'"
  id="checkbox-labeled-container"
>
  <tui-checkbox-labeled
    [formControlName]="formControlName"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [readOnly]="properties?.readOnly ?? false"
    [size]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    <div class="inner">
      <div class="text">
        <span
          class="tui-required"
          *ngIf="validators.required"
        ></span>
        <span [innerHTML]="label | kwikuiSafeHtml"></span>
      </div>
    </div>
  </tui-checkbox-labeled>
</div>
<div
  [formGroup]="formGroup"
  *ngIf="variant === 'block'"
  id="checkbox-block-container"
>
  <tui-checkbox-block
    [formControlName]="formControlName"
    [nativeId]="id"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [pseudoFocus]="focus ?? null"
    [readOnly]="properties?.readOnly ?? false"
    [size]="size"
    [contentAlign]="contentAlign"
    (focusedChange)="handleFocusedChange($event)"
  >
    <div class="inner">
      <div class="text">
        <span
          class="tui-required"
          *ngIf="validators.required"
        ></span>
        <span [innerHTML]="label | kwikuiSafeHtml"></span>
      </div>
    </div>
  </tui-checkbox-block>
</div>
